<div class="blank-layout-container justify-content-center login-bg">
  <div class="row">
    <div class="col-12 text-center text-white">
      <img [src]="'/assets/images/miscellaneous/loader.webp'" width="100" class="m-b-6" />

      @if (type ==='loading') {
      <h2 style="line-height: 1.5; letter-spacing: 1px">{{"LOADING_MODULE.TITLE" | translate}}</h2>
      <mat-progress-bar mode="indeterminate" />
      }

      @if (type ==='auto-login') {
      <h2 style="line-height: 1.5; letter-spacing: 1px">{{"MODULE_LOGIN.AUTO-LOGIN" | translate}}</h2>
      <mat-progress-bar mode="indeterminate" />
      }


    </div>
  </div>
</div>